// TODO enable eslint
/* eslint-disable react/jsx-curly-brace-presence */
import React from "react"
import PropTypes from "prop-types"
import { P } from "@infotech/uikit-text"
import Triangle from "src/icons/triangleExclamationMark.svg"
import { Link } from "react-router-dom"
import styles from "./styles.css"

const NotFoundSideModal = ({ handleUpdate, message }) => (
  <div className={styles.Container}>
    <div>
      <Triangle className={styles.Triangle} size="large" />
    </div>
    <div>
      <P className={styles.InfoBold}>Извините, что-то пошло не так.</P>
    </div>
    <div>
      <P className={styles.Info}>
        {message}. Пожалуйста,
        <span onClick={handleUpdate} className={styles.Link}>
          обновите страницу
        </span>
        или
        <Link to="/calendar" className={styles.Link}>
          вернитесь на главную.
        </Link>
      </P>
    </div>
  </div>
)

NotFoundSideModal.propTypes = {
  handleUpdate: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
}

export default NotFoundSideModal
